import React from 'react';
import { Grid, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { withStyles, WithStyles } from '@mui/styles';
import { FillDeliveryConfirmationStatus } from 'interfaces/enums/TaskStatuses/FillDeliveryConfirmationStatus';
import { ShippingStyles } from './shipping.styles';
import { IPrintLabelButton } from './types';
import VoidPickupButton from './void-pickup-button';
import PickupButton from './pickup-button';
import MarkPickedUpButton from './mark-picked-up-button';
import { showReadyForPickupButton, showVoidPickupButton } from './utils';

interface IShippingProps extends IPrintLabelButton, WithStyles<typeof ShippingStyles> {}

const PickupShippingButtons = (props: IShippingProps): JSX.Element | null => {
  const {
    orderId,
    currentPrintInformation,
    currentDeliveryInformation,
    currentFdcInformation,
    disabled,
    pharmacyInfo,
    updateShippingPage = () => {},
  } = props;

  const allowReadyForPickupButton = showReadyForPickupButton(
    pharmacyInfo?.workflow_type,
    currentFdcInformation?.statusId,
    currentDeliveryInformation?.deliveryMethod,
  );

  const allowVoidPickupButton = showVoidPickupButton(
    pharmacyInfo?.workflow_type,
    currentFdcInformation?.statusId,
    currentDeliveryInformation?.deliveryMethod,
  );
  const isAlreadyPickedUp =
    currentFdcInformation?.statusId === FillDeliveryConfirmationStatus.PickedUp;

  const displayPickUpButtonsGroup = (): JSX.Element | null => {
    const showVoidButton = !allowReadyForPickupButton && allowVoidPickupButton;
    if (allowReadyForPickupButton) {
      return (
        <PickupButton
          currentDeliveryInformation={currentDeliveryInformation}
          currentPrintInformation={currentPrintInformation}
          currentFdcInformation={currentFdcInformation}
          orderId={orderId}
          disabled={disabled}
          updateShippingPage={updateShippingPage}
        />
      );
    }
    if (isAlreadyPickedUp) {
      return (
        <Grid
          item
          style={{
            display: 'flex',
            alignItems: 'center',
            marginTop: 24,
            marginLeft: 16,
            marginBottom: 16,
            padding: '8px 12px',
            borderRadius: 4,
            backgroundColor: '#e8f5e9',
            color: '#1b5e20',
            fontWeight: 'bold',
          }}
        >
          <CheckCircleIcon style={{ marginRight: 8 }} fontSize="small" />
          <Typography variant="body2">Order was already marked as picked up.</Typography>
        </Grid>
      );
    }
    if (showVoidButton) {
      return (
        <Grid container item style={{ display: 'flex', alignItems: 'center', flexWrap: 'nowrap' }}>
          <MarkPickedUpButton
            currentDeliveryInformation={currentDeliveryInformation}
            currentPrintInformation={currentPrintInformation}
            currentFdcInformation={currentFdcInformation}
            orderId={orderId}
            updateShippingPage={updateShippingPage}
          />
          <VoidPickupButton
            currentDeliveryInformation={currentDeliveryInformation}
            currentPrintInformation={currentPrintInformation}
            currentFdcInformation={currentFdcInformation}
            orderId={orderId}
            updateShippingPage={updateShippingPage}
          />
        </Grid>
      );
    }
    return null;
  };

  return displayPickUpButtonsGroup();
};

export default withStyles(ShippingStyles)(PickupShippingButtons);
